module.exports = __webpack_public_path__ + "static/media/avatar@3x.e88c9dda.jpg";